import React from 'react';
import { connect } from 'react-redux';
import {
  onClickDone,
  addItemsConfirmAddItems,
  showConfirmSubmitModal,
} from 'actions/inventory/adjustment';
import { getFormValues } from 'redux-form';
import { error } from 'actions/notifications';
import styles from './AdjustmentDetail.css';
import ItemDetails from './ItemDetails';
import InventoryAdjustment from './InventoryAdjustment';
import AdjustmentForm from './AdjustmentForm';
import AddItemsModal from './AddItemsModal';

class AdjustmentDetail extends React.Component {
  render() {
    const { adjustmentDetail, ingredientAdjustmentDetail, search } = this.props;
    return this._shouldRenderDetail() ? (
      <div className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} adjustment-field-wrapper`}>
          <ItemDetails
            adjustmentDetail={adjustmentDetail}
            ingredientAdjustmentDetail={ingredientAdjustmentDetail}
            namespace={this._namespace()}
            renderOutlet={
              search && search.outletIds && search.outletIds.length > 1
            }
          />
          <InventoryAdjustment
            adjustmentDetail={adjustmentDetail}
            ingredientAdjustmentDetail={ingredientAdjustmentDetail}
            namespace={this._namespace()}
          />
        </div>
        <div className={styles.footer}>
          <span className="pull-right">
            <button
              className={`btn btn-primary ${styles['btn-done']}`}
              onClick={this._closeRightColumn}
            >
              Done
            </button>
          </span>
        </div>
      </div>
    ) : (
      <div className={styles.wrapper}>
        <div className={styles['form-wrapper']}>
          <AdjustmentForm
            onSubmit={this._onSubmitAdjustmentForm}
            namespace={this._namespace()}
          />
          <AddItemsModal
            onSubmit={this._onSubmitAddItems}
            namespace={this._namespace()}
          />
        </div>
      </div>
    );
  }

  _closeRightColumn = () => {
    this.props.dispatch(onClickDone());
  };

  _onSubmitAddItems = addItemsFormValues => {
    const { adjustmentForm } = this.props;
    const values = { ...addItemsFormValues };
    values.quantity = String(
      parseFloat(addItemsFormValues.quantity).toFixed(2)
    );
    this.props.dispatch(
      addItemsConfirmAddItems(
        addItemsFormValues,
        adjustmentForm.adjustments,
        this._namespace()
      )
    );
  };

  _onSubmitAdjustmentForm = values => {
    let hasDifference = false;
    values.adjustments.forEach(adjustment => {
      if (
        Math.abs(
          parseFloat(adjustment.beginning_stock) -
            parseFloat(adjustment.quantity)
        ) > 0.001
      ) {
        hasDifference = true;
      }
    });
    if (hasDifference) {
      this.props.dispatch(showConfirmSubmitModal());
    } else {
      this.props.dispatch(error('Please add Adjustment Stock before saving'));
    }
  };

  _namespace = () => {
    const { search } = this.props;
    if (search) {
      return search.namespace;
    }
    return '';
  };

  /**
   * Either should render detail or form
   * @private
   */
  _shouldRenderDetail = () => {
    const namespace = this._namespace();
    const { adjustmentDetail, ingredientAdjustmentDetail } = this.props;
    if (namespace === 'items') {
      return !!adjustmentDetail;
    }
    return !!ingredientAdjustmentDetail;
  };
}

function mapStateToProps(state) {
  const {
    adjustments,
    adjustmentDetail,
    showAddItemsModal,
    ingredientAdjustmentDetail,
  } = state.inventory.adjustment;
  return {
    adjustments,
    adjustmentDetail,
    showAddItemsModal,
    ingredientAdjustmentDetail,
    adjustmentForm: getFormValues('adjustment')(state),
    search: getFormValues('search')(state),
  };
}

export default connect(mapStateToProps)(AdjustmentDetail);
